










import { Vue, Component, Prop } from 'vue-property-decorator'
import Card from '@/components/Card.vue'
@Component({
  components: {
    Card
  }
})
export default class Index extends Vue {

  created () {
    window.location.replace('https://bancaprofilo.tinaba.it/');
  }

}
